<template>
    <v-dialog v-model="dialog" width="700" :fullscreen="isMobileOrTablet()" persistent>
        <v-card class="rounded-lg" style="display: flex; flex-direction: column; height: 100%;">
            <v-card-title style="background-color: #1a5b0f !important; display: flex; justify-content: space-between; align-items: center;">
                <div class="w-75 text-truncate text-white">
                    <span class="font-weight-bold text-h6">{{ dialog_title }}</span>
                    <div class="text-caption">{{ dialog_sub_title }}</div>
                </div>
                <v-btn v-if="loading == false" flat icon color="darkGreen" @click="closeDialog()">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text style="overflow-y: auto; max-height: calc(100vh - 100px);">
                <v-form ref="form" class="mt-2">
                    <v-row v-if="compliance.is_upload == true" dense>
                        <v-col cols="12">
                            <div class="font-weight-bold text-red">Notes:</div>
                            <div class="text-red">*Please select all files you wish to upload at once.</div>
                            <div class="text-red">*Also please submit files with short names.</div>
                            <div v-if="compliance.id == 2">
                                <div class="text-red mt-4 font-weight-bold">For TQ and TOS please submit the following:</div>
                                <ul class="text-red font-weight-bold ml-4">
                                    <li>TQ</li>
                                    <li>TQ for printing (This may also submit after the TQ is approved)</li>
                                    <li>TOS</li>
                                </ul>
                            </div>
                            <!-- “This compliance require {{ this.compliance.max_upload }} pdf uploads.” -->
                        </v-col>
                        <v-col cols="12">
                            <v-file-upload
                                v-model="files"
                                accept="application/pdf"
                                type="file"
                                multiple
                                clearable
                                show-size
                                rounded="lg"
                                height="310"
                                scrim="darkGreen"
                            />
                        </v-col>
                    </v-row>
                    <v-row dense class="mt-3">
                        <v-col cols="12">
                            <v-autocomplete
                                v-model="faculty_load"
                                :rules="[newFormRules.validFacultyLoad]"
                                @update:model-value="loadFacultyIncludes()"
                                label="Course Load"
                                variant="outlined"
                                rounded="lg"
                                color="darkGreen"
                                :items="facultyLoadData"
                                :item-title="getItemTitle"
                                item-value="id"
                                return-object
                                :loading="loading"
                                >
                            </v-autocomplete>
                        </v-col>
                        <v-col cols="12" v-if="courseOutcomeSectionVisible">
                            <div class="d-flex align-center justify-space-between mb-3">
                                <div class="d-flex align-center ga-2">
                                    <span class="text-caption text-grey">Course Outcomes Status:</span>
                                    <v-chip :color="hasCourseOutcomes ? 'success' : 'error'" variant="outlined" size="small" class="font-weight-bold">
                                        <v-icon size="small" class="mr-1">{{ hasCourseOutcomes ? 'mdi-check-circle' : 'mdi-alert-circle' }}</v-icon>
                                        {{ hasCourseOutcomes ? 'Available' : 'Not Available' }}
                                    </v-chip>
                                </div>
                                <v-btn size="small" variant="elevated" color="primary" @click="openCourseOutcomesDialog()">
                                    Add Course Outcome
                                </v-btn>
                            </div>
                            <div v-if="courseOutcomeChecked && courseOutcomes.length > 0">
                                <table simple-tabledense class="course-outcome-table">
                                    <thead>
                                        <tr>
                                            <th class="text-left text-body-2" style="width: 60px;">Code</th>
                                            <th class="text-left text-body-2 pl-4">Description</th>
                                            <th class="text-right text-body-2" style="width: 70px;">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="outcome in courseOutcomes" :key="outcome.id">
                                            <td class="text-caption px-2 py-3">{{ outcome.code }}</td>
                                            <td class="text-caption px-2 py-3 pl-4">{{ outcome.description }}</td>
                                            <td class="text-right px-2 py-3">
                                                <v-btn size="x-small" variant="elevated" color="darkGreen" @click="openEditCourseOutcome(outcome)">Edit</v-btn>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div v-else-if="courseOutcomeChecked" class="text-caption text-grey pa-2">
                                No course outcomes yet. Add one before submitting.
                            </div>
                            <div v-else class="text-caption text-grey pa-2">
                                Checking course outcomes...
                            </div>
                        </v-col>
                        <v-col v-if="compliance.is_sorted_course" cols="12">
                            <v-select
                                v-model="faculty_includes"
                                label="Faculties Includes"
                                variant="outlined"
                                rounded="lg"
                                color="darkGreen"
                                chips
                                multiple
                                :items="facultyIncludesData"
                                :item-title="getFacultyName"
                                item-value="id"
                                return-object
                                :rules="[newFormRules.required]"
                                :loading="loading"
                                >
                            </v-select>
                        </v-col>
                        <v-col cols="12">
                            <v-autocomplete
                                v-model="reviewers_department"
                                label="Reviewer's Department/Program"
                                clearable
                                :rules="[formRules.required]"
                                variant="outlined"
                                rounded="lg"
                                type="text"
                                color="darkGreen"
                                :items="programData"
                                item-title="name"
                                item-value="id"
                                >
                                <template v-slot:details>
                                    <div style="color: red; font-size: 0.75rem; margin-right: 60px;">
                                        This is where you select a department/program you want this compliance to be reviewed by.
                                    </div>
                                </template>
                            </v-autocomplete>
                        </v-col>
                        <v-col v-if="compliance.id == 2" cols="12">
                            <v-text-field
                                v-model="number_of_copies"
                                :rules="[formRules.required]"
                                label="No. of Copies"
                                variant="outlined"
                                rounded="lg"
                                type="text"
                                color="darkGreen"
                                :loading="loading"
                                >
                                <template v-slot:details>
                                    <div style="color: red; font-size: 0.75rem; margin-right: 60px;">
                                        This will be the number of copies for printing of the examination.
                                    </div>
                                </template>
                            </v-text-field>
                        </v-col>
                        <v-col v-if="compliance.id == 2" cols="12">
                            <v-select
                                v-model="exam_day"
                                :rules="[formRules.required]"
                                label="Exam Day"
                                variant="outlined"
                                rounded="lg"
                                type="text"
                                color="darkGreen"
                                :loading="loading"
                                :items="examDayData"
                                item-title="name"
                                item-value="id"
                                >
                                <template v-slot:details>
                                    <div style="color: red; font-size: 0.75rem; margin-right: 60px;">
                                        This will be the exam day for the examination.
                                    </div>
                                </template>
                            </v-select>
                        </v-col>
                        <v-col cols="12">
                            <v-textarea
                                v-model="note"
                                label="Notes"
                                variant="outlined"
                                rounded="lg"
                                color="darkGreen"
                                :loading="loading"
                                >
                            </v-textarea>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="pa-3" style="margin-top: auto;">
                <v-spacer></v-spacer>
                <v-btn class="mr-1" :disabled="loading" variant="outlined" elevation="1" @click="closeDialog()">Cancel</v-btn>
                <v-tooltip v-if="saveTooltipVisible" activator="parent" location="top">
                    <template #activator="{ props }">
                        <v-btn class="mr-1" v-bind="props" :loading="loading" :disabled="saveDisabled" variant="elevated" elevation="1" color="darkGreen" @click="validateForm()">
                            Save
                        </v-btn>
                    </template>
                    <span>Please add at least one course outcome before submitting.</span>
                </v-tooltip>
                <v-btn v-else class="mr-1" :loading="loading" :disabled="saveDisabled" variant="elevated" elevation="1" color="darkGreen" @click="validateForm()">
                    Save
                </v-btn>
                <!-- <v-btn class="mr-1" :loading="loading" variant="elevated" elevation="1" color="darkGreen" @click="validateForm()">
                    Save
                </v-btn> -->
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="confirmSubmit" width="450" persistent>
        <v-card color="secondary" rounded="lg" class="pa-2">
            <v-card-text>
                <div class="font-weight-bold mt-2 text-h6">Are you sure you want to submit your compliance?</div>
                <div class="font-weight-light mt-2">Note: Once submitted, some details may not be updated. Please review your compliance information carefully before proceeding.</div>
            </v-card-text>
            <template v-slot:actions>
            <v-spacer></v-spacer>

            <v-btn @click="confirmSubmit = false" :disabled="loading" variant="outlined">
                Cancel
            </v-btn>
            <v-btn :loading="loading" @click="submitCompliance()" color="darkGreen" variant="elevated">
                Confirm
            </v-btn>
            </template>
        </v-card>
    </v-dialog>

    <CourseOutcomesDialog ref="CourseOutcomesDialog" @refresh="onCourseOutcomesRefresh" />
</template>

<script>
import axios from 'axios';
import { defineComponent } from 'vue'
import { useSnackbar } from '@/composables/useSnackbar'
import CourseOutcomesDialog from './CourseOutcomesDialog.vue'

export default defineComponent({
     emits: ["refresh"],
     components: {
         CourseOutcomesDialog
     },
     data(){
        return {
            dialog: false,
            dialog_title: null,
            dialog_sub_title: null,
            action: null,
            loading: false,

            id: null,
            files: [],
            reviewers_department: null,
            faculty_load: null,
            number_of_copies: null,
            exam_day: null,
            user_id: null,
            compliance_id: null,
            note: null,
            term_id: null,
            faculty_includes: [],
            links: null,
            semester_schoolyear_id: null,

            compliance: null,
            facultyLoadData: [],
            facultyIncludesData: [],
            programData: [],
            confirmSubmit: false,
            examDayData: ['Day 1', 'Day 2', 'Day 3', 'Day 4', 'Day 5', 'Day 6', 'Day 7',],
            courseOutcomes: [],
            hasCourseOutcomes: false,
            courseOutcomeChecked: false,
            newFormRules: {
                required: (value) => value && value.length > 0 || 'This field is required',
                validFacultyLoad: (value) => {
                    if (!value) return true;
                    return this.facultyLoadData.some((item) => item.id === value.id) || "Invalid selection";
                },
            },
        }
     },
     computed: {
        courseOutcomeSectionVisible() {
            return this.compliance?.id === 1 && this.faculty_load && this.faculty_load.id
        },
        saveDisabled() {
            if (this.loading) return true
            if (this.compliance?.id !== 1) return false
            return !this.faculty_load || !this.faculty_load.id || !this.courseOutcomeChecked || !this.hasCourseOutcomes
        },
        saveTooltipVisible() {
            return this.compliance?.id === 1 && this.faculty_load && this.faculty_load.id && this.courseOutcomeChecked && !this.hasCourseOutcomes
        }
    },
     methods: {
        initAdd(data){
            this.dialog = true
            this.dialog_title = data.compliance_name
            this.dialog_sub_title = data.is_upload ? 'Submit compliance with' + ' "' + data.upload_type + '" ' + 'uploads' : 'Submit compliance for checking'
            this.action = 'add'

            this.compliance = data
            this.files = null
            this.term_id = null
            this.user_id = this.$store.state.user.id
            this.semester_schoolyear_id = this.$store.state.semester_schoolyear.id
            this.faculty_includes = []
            this.number_of_copies = null
            this.faculty_load = null
            this.courseOutcomes = []
            this.hasCourseOutcomes = false
            this.courseOutcomeChecked = false

            this.loadCoursesWithoutTerm()
            this.loadReviewersDepartment()
        },
        initAddWithTerm(data,schedule){
            this.dialog = true
            this.dialog_title = data.compliance_name + ' (' + schedule.term.name + ')'
            this.dialog_sub_title = 'Submit new compliance for ' + schedule.term.name
            this.action = 'add'

            this.compliance = data
            this.files = null
            this.term_id = schedule.term_id
            this.user_id = this.$store.state.user.id
            this.semester_schoolyear_id = this.$store.state.semester_schoolyear.id
            this.faculty_includes = []
            this.faculty_load = null
            this.number_of_copies = null
            this.courseOutcomes = []
            this.hasCourseOutcomes = false
            this.courseOutcomeChecked = false

            this.loadCoursesWithTerm()
            this.loadReviewersDepartment()
        },
        async loadCoursesWithoutTerm(){
            const { showSnackbar } = useSnackbar()
            if(this.compliance.is_sorted_course == true){
                this.loading = true
                const token = localStorage.getItem('aums-token')
                await axios.get(process.env.VUE_APP_SERVER_URL + '/faculty-load/findAllLoadWithoutFileUploadSorted/' + this.$store.state.user.id + '/' + this.$store.state.semester_schoolyear.id + '/' + this.compliance.id,
                { headers:
                    { 
                        'Authorization': `Bearer ${token}`,
                    }
                }
                ).then((res)=>{
                    if(res.data){
                        this.loading = false
                        this.facultyLoadData = res.data
                    }
                }).catch((error)=>{
                    if(error.response.status == 401){
                        this.loading = false
                        showSnackbar('Token expired! Logging out..')

                        localStorage.removeItem("vuex");
                        localStorage.removeItem("aums-token");
                        window.location.reload();
                    }
                    else{
                        console.log(error)
                    }
                });
            }
            else{
                this.loading = true
                const token = localStorage.getItem('aums-token')
                await axios.get(process.env.VUE_APP_SERVER_URL + '/faculty-load/findAllLoadWithoutFileUpload/' + this.$store.state.user.id + '/' + this.$store.state.semester_schoolyear.id + '/' + this.compliance.id,
                { headers:
                    { 
                        'Authorization': `Bearer ${token}`,
                    }
                }
                ).then((res)=>{
                    if(res.data){
                        this.loading = false
                        this.facultyLoadData = res.data
                    }
                }).catch((error)=>{
                    if(error.response.status == 401){
                        this.loading = false
                        showSnackbar('Token expired! Logging out..')

                        localStorage.removeItem("vuex");
                        localStorage.removeItem("aums-token");
                        window.location.reload();
                    }
                    else{
                        console.log(error)
                    }
                });
            }
        },
        async loadCoursesWithTerm(){
            const { showSnackbar } = useSnackbar()
            if(this.compliance.is_sorted_course == true){
                this.loading = true
                const token = localStorage.getItem('aums-token')
                await axios.get(process.env.VUE_APP_SERVER_URL + '/faculty-load/findAllLoadWithoutFileUploadWithTermSorted/' + this.$store.state.user.id + '/' + this.$store.state.semester_schoolyear.id + '/' + this.term_id + '/' + this.compliance.id,
                { headers:
                    { 
                        'Authorization': `Bearer ${token}`,
                    }
                }
                ).then((res)=>{
                    if(res.data){
                        this.loading = false
                        this.facultyLoadData = res.data
                    }
                }).catch((error)=>{
                    if(error.response.status == 401){
                        this.loading = false
                        showSnackbar('Token expired! Logging out..')

                        localStorage.removeItem("vuex");
                        localStorage.removeItem("aums-token");
                        window.location.reload();
                    }
                    else{
                        console.log(error)
                    }
                });
            }
            else{
                this.loading = true
                const token = localStorage.getItem('aums-token')
                await axios.get(process.env.VUE_APP_SERVER_URL + '/faculty-load/findAllLoadWithoutFileUploadWithTerm/' + this.$store.state.user.id + '/' + this.$store.state.semester_schoolyear.id + '/' + this.term_id + '/' + this.compliance.id,
                { headers:
                    { 
                        'Authorization': `Bearer ${token}`,
                    }
                }
                ).then((res)=>{
                    if(res.data){
                        this.loading = false
                        this.facultyLoadData = res.data
                    }
                }).catch((error)=>{
                    if(error.response.status == 401){
                        this.loading = false
                        showSnackbar('Token expired! Logging out..')

                        localStorage.removeItem("vuex");
                        localStorage.removeItem("aums-token");
                        window.location.reload();
                    }
                    else{
                        console.log(error)
                    }
                });
            }
        },
        async loadFacultyIncludes(){
            const { showSnackbar } = useSnackbar()
            this.reviewers_department = this.faculty_load?.program_id || null
            if(!this.faculty_load || !this.faculty_load.id){
                this.courseOutcomes = []
                this.hasCourseOutcomes = false
                this.courseOutcomeChecked = false
                this.facultyIncludesData = []
                return
            }

            this.courseOutcomes = []
            this.hasCourseOutcomes = false
            this.courseOutcomeChecked = false

            if(this.faculty_includes && this.faculty_includes.length > 0) { this.faculty_includes = [] }

            if(!this.compliance.is_term_separated){
                this.loading = true
                const token = localStorage.getItem('aums-token')
                await axios.get(process.env.VUE_APP_SERVER_URL + '/faculty-load/findAllFacultyWithSameLoad/' + this.faculty_load?.code + '/' + this.$store.state.semester_schoolyear.id + '/' + this.compliance.id,
                { headers:
                    { 
                        'Authorization': `Bearer ${token}`,
                    }
                }
                ).then((res)=>{
                    if(res.data){
                        this.loading = false
                        this.facultyIncludesData = res.data
                        
                        if(this.compliance.is_sorted_course){
                            this.faculty_includes = res.data.filter(
                                faculty => faculty.user.id == this.$store.state.user.id
                            );
                        } else {
                            this.faculty_includes = res.data.filter(
                                faculty => faculty.id === this.faculty_load.id
                            );
                        }
                        
                    }
                }).catch((error)=>{
                    if(error.response.status == 401){
                        this.loading = false
                        showSnackbar('Token expired! Logging out..')

                        localStorage.removeItem("vuex");
                        localStorage.removeItem("aums-token");
                        window.location.reload();
                    }
                    else{
                        console.log(error)
                    }
                });
            }
            else{
                const token = localStorage.getItem('aums-token')
                await axios.get(process.env.VUE_APP_SERVER_URL + '/faculty-load/findAllFacultyWithSameLoadAndTerm/' + this.faculty_load?.code + '/' + this.$store.state.semester_schoolyear.id + '/' + this.term_id + '/' + this.compliance.id,
                { headers:
                    { 
                        'Authorization': `Bearer ${token}`,
                    }
                }
                ).then((res)=>{
                    if(res.data){
                        this.loading = false
                        this.facultyIncludesData = res.data
                        if(this.compliance.is_sorted_course){
                            this.faculty_includes = res.data.filter(
                                faculty => faculty.user.id == this.$store.state.user.id
                            );
                        } else {
                            this.faculty_includes = res.data.filter(
                                faculty => faculty.id === this.faculty_load.id
                            );
                        }
                    }
                }).catch((error)=>{
                    if(error.response.status == 401){
                        this.loading = false
                        showSnackbar('Token expired! Logging out..')

                        localStorage.removeItem("vuex");
                        localStorage.removeItem("aums-token");
                        window.location.reload();
                    }
                    else{
                        console.log(error)
                    }
                });
            }

            if(this.compliance.id == 1){
                this.fetchCourseOutcomes();
            }
        },
        async fetchCourseOutcomes(){
            const { showSnackbar } = useSnackbar()
            this.loading = true
            const token = localStorage.getItem('aums-token')
            await axios.get(process.env.VUE_APP_SERVER_URL + '/course-outcomes/findAllByCourseCode/' + this.faculty_load?.code + '/' + this.$store.state.semester_schoolyear.id,
            { headers:
                { 
                    'Authorization': `Bearer ${token}`,
                }
            }
            ).then((res)=>{
                this.loading = false
                this.courseOutcomes = res.data || []
                this.hasCourseOutcomes = this.courseOutcomes.length > 0
                this.courseOutcomeChecked = true
            }).catch((error)=>{
                if(error.response.status == 401){
                    this.loading = false
                    showSnackbar('Token expired! Logging out..')
                    localStorage.removeItem("vuex");
                    localStorage.removeItem("aums-token");
                    window.location.reload();
                }
                else{
                    console.log(error)
                    this.loading = false
                }
            });
        },
        onCourseOutcomesRefresh(){
            this.fetchCourseOutcomes();
        },
        async openCourseOutcomesDialog(){
            const program = this.faculty_load?.program || await this.getProgramById(this.faculty_load?.program_id);
            if (!program) {
                const { showSnackbar } = useSnackbar()
                showSnackbar('Unable to load program details. Please try again.');
                return;
            }
            console.log('Opening Course Outcomes Dialog with faculty_load:', this.faculty_load, 'and program:', program);
            this.$refs.CourseOutcomesDialog.initAdd(this.faculty_load, program);
        },
        async openEditCourseOutcome(outcome){
            const program = this.faculty_load?.program || await this.getProgramById(this.faculty_load?.program_id);
            if (!program) {
                const { showSnackbar } = useSnackbar()
                showSnackbar('Unable to load program details. Please try again.');
                return;
            }
            this.$refs.CourseOutcomesDialog.initEdit(outcome, this.faculty_load, program);
        },
        async getProgramById(programId){
            const { showSnackbar } = useSnackbar()
            try {
                const res = await axios.get(process.env.VUE_APP_SERVER_URL + '/programs/' + programId);
                return res.data;
            } catch (error) {
                if(error.response.status == 401){
                    showSnackbar('Token expired! Logging out..')
                    localStorage.removeItem("vuex");
                    localStorage.removeItem("aums-token");
                    window.location.reload();
                }
                else{
                    console.log(error)
                }
                return null;
            }
        },
        async loadReviewersDepartment(){
            await axios.get(process.env.VUE_APP_SERVER_URL + '/programs')
            .then(res => {
                this.programData = res.data
            });
        },
        getItemTitle(item) {
            if(this.compliance.is_sorted_course == true){
                return `${item.code} - ${item.title}`;
            }
            else{
                return `${item.code} - ${item.title} (${item.section_code})`;
            }
        },
        getFacultyName(item){
            return `${item.user?.fname} ${item.user?.lname} (${item.section_code})`;
        },
        disableFirstOption(item) {
            return { disabled: item.user.id == this.$store.state.user.id };
        },
        async validateForm() {
        const { showSnackbar } = useSnackbar()
        const form = this.$refs.form;
        if (!form) return;

        const { valid } = await form.validate();

        if (!valid) {
            return;
        }

        if (this.compliance?.is_upload) {
            if (!this.files || this.files.length === 0) {
            showSnackbar('Please upload files.');
            return;
            }

            // Validate all files are PDFs
            const invalidFiles = this.files.filter(
            (file) =>
                file.type !== "application/pdf" &&
                !file.name.toLowerCase().endsWith(".pdf")
            );

            if (invalidFiles.length > 0) {
            showSnackbar('All uploaded files must be PDF format.');
            return;
            }

            if(this.compliance.id == 2){
                if(this.files.length < 2){
                    showSnackbar('You must upload 2 PDF files or more for TQ and TOS.');
                    return;
                }
            }

            // If you have a required count
            // if (this.compliance?.max_upload && this.files.length !== this.compliance.max_upload) {
            //     showSnackbar(`You must upload exactly ${this.compliance.max_upload} PDF file(s).`);
            //     return;
            // }
        }

        if(this.compliance.id == 1 && !this.hasCourseOutcomes){
           showSnackbar('Please add course outcomes for this course before submitting compliance.');
          return;
        }

        // If everything is OK, show the confirm dialog
        this.confirmSubmit = true;
        },
        submitCompliance(){
            const { showSnackbar } = useSnackbar()
                this.loading = true 

                let formData = new FormData()

                let form = {
                    user_id: this.user_id,
                    compliance_id: this.compliance.id,
                    faculty_includes: this.faculty_includes,
                    note: this.note || null,
                    links: this.links || null,
                    semester_schoolyear_id: this.semester_schoolyear_id,
                    term_id: this.term_id || null,
                    reviewers_department: this.reviewers_department,
                    number_of_copies: this.number_of_copies || null,
                    exam_day: this.exam_day || null
                }

                if (this.files && this.files.length > 0) {
                    for (let i = 0; i < this.files.length; i++) {
                        formData.append('files', this.files[i]);
                    }
                }

                formData.append('data', JSON.stringify(form))

                const token = localStorage.getItem('aums-token')

                if(this.action == 'add'){
                    axios.post(process.env.VUE_APP_SERVER_URL + '/compliance-upload', formData,
                    { headers:
                        { 
                            'Authorization': `Bearer ${token}`,
                        }
                    }
                    ).then((res)=>{
                        if(res.data.status == 201){
                            this.confirmSubmit = false
                            this.loading = false
                            this.$emit('refresh')
                            showSnackbar('Compliances successfully submitted!')
                            this.$refs.form.reset()
                            this.dialog = false
                        }
                    }).catch((error)=>{
                        if(error.response.status == 401){
                            this.confirmSubmit = false
                            this.loading = false
                            showSnackbar('Token expired! Logging out..')
                            localStorage.removeItem("vuex");
                            localStorage.removeItem("aums-token");
                            window.location.reload();
                        }
                        else{
                            console.log(error)
                        }
                    })
                }
        },
        closeDialog(){
            this.$refs.form.reset()
            this.dialog = false
        }
     }
})
</script>

<style scoped>
.course-outcome-table {
  display: table;
  width: 100% !important;
  max-width: 100%;
  min-width: 0;
  border-collapse: collapse;
  table-layout: fixed;
}
.course-outcome-table thead th,
.course-outcome-table tbody td {
  word-break: break-word;
}
.course-outcome-table thead th {
  padding: 0px 0px 12px 0px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}
.course-outcome-table tbody td {
  padding: 12px 16px;
  vertical-align: middle;
}
.course-outcome-table tbody tr {
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}
.course-outcome-table tbody tr:last-child {
  border-bottom: none;
}
.course-outcome-table th.text-right,
.course-outcome-table td.text-right {
  text-align: right;
}
</style>